import { MerchantSelectionForm } from './merchant-selection-form.interface'

export const createMerchantSelectionForm = (): MerchantSelectionForm => {
  return {
    merchantName: '',
  }
}
